<template>
  <v-container fluid class="signup-container">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-5 signup-card">
          <v-form class="ma-auto">
            <h1 class="text-center mt-4 mb-4">Sign up</h1>
            <v-alert v-if="error" :type="messageType" dismissible class="mb-4">
              {{ error }}
            </v-alert>
            <small v-if="!isValidForm" class="mb-3">Please enter a valid email and phone number.</small>

            <br /><br />
            <MazInput block label="Username" v-model="username" class="mb-3 full-width" /><br />
            <MazInput block label="First Name" v-model="firstname" class="mb-3" /><br />
            <MazInput block label="Last Name" v-model="lastname" class="mb-3" /><br />
            <MazPhoneNumberInput v-model="telephone" v-model:country-code="countryCode" show-code-on-list
              :preferred-countries="['FR', 'BE', 'DE', 'GB', 'US', 'CA']" :ignored-countries="['AC']"
              @update="results = $event" class="mb-3 phone-input" block />

            <MazInput block label="Email" v-model="email" class="mb-3" /><br />
            <MazInput block label="Password" v-model="password" :type="show ? 'text' : 'password'"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show = !show" class="mb-3 mr-2" /><br />
            <MazInput block label="Re-enter Password" v-model="passwordverify" :type="show ? 'text' : 'password'"
              class="mb-3" /><br />
          </v-form><br />
          <v-btn color="secondary" @click="signup" :disabled="!isValidForm" :loading="loading">Sign Up</v-btn>
          <v-btn v-if="!isMobile" class="close-btn" @click="$emit('close')">Close</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { reportError } from '@/services/errors';
import axios from '@/services/http';
import creds from '@/whatsapp-tracking-361713-97a0a2bb9e20.json'; // Adjust the import path as necessary
import { GoogleSpreadsheet } from '@/services/spreadsheet';
const SHA256 = require('crypto-js/sha256');
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput';
import MazInput from 'maz-ui/components/MazInput';
export default {
  name: 'SignUpPage',
  props: {
    isMobile: Boolean,
  },
  components: {
    MazPhoneNumberInput,
    MazInput,
  },
  data() {
    return {
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      passwordverify: '',
      countryCode: 'GB',
      telephone: '',
      username: '',
      show: false,
      loading: false,
      error: '',
    };
  },
  computed: {
    isValidForm() {
      const EMAIL_REGEX = /\S+@\S+\.\S+/;
      const emailValid = EMAIL_REGEX.test(this.email);
      return emailValid;
    },
  },
  methods: {
    resetForm() {
      this.firstname = '';
      this.lastname = '';
      this.email = '';
      this.password = '';
      this.passwordverify = '';
      this.telephone = '';
      this.countryCode = 'GB';
      this.username = '';
      this.show = false;
      this.error = '';
      this.loading = false;
    },
    async sendUserEmail() {
      try {
        await axios({
          method: 'post',
          url: 'https://wildtrack-frontend.nw.r.appspot.com/send-email',
          data: {
            subject: `Welcome to WildTrackPro, ${this.username}!`,
            body: 'Test',
            recipient_email: this.email,
            is_welcome: true,
            group: 'WildTrackPro',
          },
        });
      } catch (error) {
        reportError(error);
      }
    },
    async runCloudFunction(data) {
      try {
        await axios({
          method: 'post',
          url: 'https://us-central1-wildtrack-367613.cloudfunctions.net/create_user',
          data: data,
        });
      } catch (error) {
        reportError(error);
      }
    },
    async runCloudFunctionGrp(data) {
      try {
        await axios({
          method: 'post',
          // or 'post', 'put', etc, based on your cloud function
          url: 'https://europe-west2-wildtrack-367613.cloudfunctions.net/create_group',
          data: data,
        });
      } catch (error) {
        reportError(error);
      }
    },
    async signup() {
      if (this.loading) return;
      try {
        this.loading = true;
        if (!this.isValidForm) {
          this.error = 'Please ensure all fields are correctly filled out.';
          this.loading = false;
          return;
        }
        const formattedPhone = this.telephone.replace(/\s|\+/g, '');
        const passwordHash = `A${JSON.stringify(SHA256(this.password).words)}`;
        const userObject = {
          username: this.username.trim(),
          password: passwordHash,
          email: this.email,
          first_name: this.firstname,
          last_name: this.lastname,
          phone: formattedPhone,
          permissions: '[]',
          site_permissions: JSON.stringify([]),
          app_permissions: JSON.stringify(['USER']),
          groups: '',
          download_access: false,
          forms_access: false,
          cull_access: true,
          created_at: Date.now().toString(),
          bypass_tutorial: false,
          electronic_signature: false,
          paid: true,
          bio: 'This is your bio.',
        };

        // Assuming the Google Spreadsheet logic is correct and creds are properly configured
        try {
          const doc = new GoogleSpreadsheet('1_QB8JSWR_AINfhpKFLp95NjLP-uFHWd9j1dbNnk2EAk');
          await doc.useServiceAccountAuth({
            client_email: creds.client_email,
            private_key: creds.private_key.replace(/\\n/g, '\n'),
          });
          await doc.loadInfo();
          const sheet = doc.sheetsByTitle['user_db'];
          const row = await sheet.getRows();
          let users_array = row.map((r) => r.username);
          let numbers_array = row.map((r) => r.phone);
          let emails_array = row.map((r) => r.email);
          const normalize = (s) => (s || '').toLowerCase().replace(/\s/g, '');
          const normalizedNewUsername = normalize(this.username);
          if (users_array.some((u) => normalize(u) === normalizedNewUsername)) {
            this.error = 'Username already exists. Please try again.';
            return 0;
          }
          if (numbers_array.includes(formattedPhone)) {
            this.error =
              "Phone number already exists in system. If this isn't you, please contact us at support@wildtrackpro.com";
            return 0;
          }
          if (emails_array.includes(this.email)) {
            this.error =
              "Email already exists in system. If this isn't you, please contact us at support@wildtrackpro.com";
            return 0;
          }

          const orgdoc = new GoogleSpreadsheet('1Q_YojT0KtC61QCLIZfTJdonXHG1EWwYMlm5fz9PACA4');
          await orgdoc.useServiceAccountAuth({
            client_email: creds.client_email,
            private_key: creds.private_key,
          });
          await orgdoc.loadInfo();
          const orgsheet = orgdoc.sheetsByTitle['orgs_db'];
          const orgrows = await orgsheet.getRows();
          const existingGroupNames = orgrows.map((r) => r.group_name);

          // Generate unique group name
          let groupSuffix = Math.floor(1000 + Math.random() * 9000);
          let proposedGroupName = `${this.username.trim()}-${groupSuffix}`;
          while (existingGroupNames.includes(proposedGroupName)) {
            groupSuffix = Math.floor(1000 + Math.random() * 9000);
            proposedGroupName = `${this.username.trim()}-${groupSuffix}`;
          }

          // Store this for cloud function and user object
          userObject.groups = `WildTrackPro Demo Group,${proposedGroupName}`;

          await sheet.addRow(userObject);
          await this.runCloudFunction(userObject);

          await orgsheet.addRow({
            group_name: proposedGroupName,
            admin_array: this.username.trim(),
            user_array: this.username.trim(),
            site_array: JSON.stringify([
              'Ulster',
              'Munster',
              'Shetland',
              'Orkney',
              'Outer Hebrides',
              'London',
              'South West',
              'Yorkshire and Humber',
              'North Wales',
              'Mid Wales',
              'East of England',
              'South East',
              'East Midlands',
              'West Midlands',
              'North East',
              'North West',
              'Isle of Man',
              'Connaught',
              'Leinster',
              'Highland',
              'Aberdeenshire',
              'Tayside',
              'Fife',
              'Lothian',
              'Scottish Borders',
              'Glasgow',
              'Ayrshire',
              'Dumfries and Galloway',
              'Argyll and Bute',
              'South Wales',
              'UK ALL',
            ]),
            type: 'user',
            contribute_to_science: false,
          });
          await this.runCloudFunctionGrp({
            username: this.username.trim(),
            group: proposedGroupName,
            type: 'user',
          });
          // Update demo group with new user
          let org = orgrows.filter((r) => r.group_name === 'WildTrackPro Demo Group')[0];
          let admins = org.admin_array.split(',');
          let users = org.user_array.split(',');
          admins.push(this.username.trim());
          users.push(this.username.trim());
          org.admin_array = admins.join(',');
          org.user_array = users.join(',');
          await org.save();

          // Await this too
          await this.sendUserEmail();

          this.error = 'Signup successful!';
          this.resetForm();
          this.$emit('close');
          this.$emit('success');
          this.$parent.dialog = false;
        } catch (error) {
          reportError(error);
          this.error = 'An error occurred during signup.';
        } finally {
          this.loading = false;
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.signup-container {
  min-height: 0;
  height: auto;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.signup-card {
  background: #2A2B3C !important;
  color: #f5f5f7 !important;
  border-radius: 18px !important;
  box-shadow: 0 8px 32px rgba(42,43,60,0.18), 0 1.5px 6px rgba(42,43,60,0.12);
  max-width: 420px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 28px 24px 28px;
  border: 1.5px solid #23243a;
  position: relative;
}

.v-form {
  width: 100%;
}

h1.text-center {
  color: #f5f5f7;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 18px;
  letter-spacing: 0.5px;
}

.v-alert {
  background: #23243a !important;
  color: #ffbdbd !important;
  border-radius: 10px !important;
  border: 1.5px solid #ffbdbd33 !important;
}

small {
  color: #ffbdbd;
  font-size: 0.98rem;
  margin-bottom: 10px;
  display: block;
}

.phone-input {
  width: 100% !important;
}

.v-btn {
  background: linear-gradient(135deg, #23243a 0%, #2A2B3C 100%) !important;
  color: #f5f5f7 !important;
  border-radius: 10px !important;
  font-weight: 500;
  font-size: 1rem;
  text-transform: none;
  padding: 10px 32px !important;
  min-width: 140px;
  box-shadow: 0 4px 12px rgba(42,43,60,0.12);
  margin-top: 12px;
  margin-right: 12px;
}

.close-btn {
  background: linear-gradient(135deg, #ffbdbd 0%, #e57373 100%) !important;
  color: #23243a !important;
  border-radius: 10px !important;
  font-weight: 500;
  font-size: 1rem;
  text-transform: none;
  padding: 10px 32px !important;
  min-width: 140px;
  box-shadow: 0 4px 12px rgba(255,189,189,0.12);
  margin-top: 12px;
  margin-right: 0;
}

.v-btn:active {
  background: #23243a !important;
}

/* MazInput overrides */
.MazInput, .MazPhoneNumberInput {
  --maz-color: #2A2B3C;
  --maz-bg-color: #23243a;
  --maz-border-radius: 12px;
  --maz-font-color: #f5f5f7;
  --maz-label-color: #f5f5f7;
  --maz-placeholder-color: #bdbdbd;
  --maz-border-color: #23243a;
  --maz-focus-border-color: #4caf50;
  --maz-icon-color: #f5f5f7;
  margin-bottom: 18px !important;
}

.MazInput input, .MazPhoneNumberInput input {
  background: #23243a !important;
  color: #f5f5f7 !important;
  border-radius: 12px !important;
  border: 1.5px solid #23243a !important;
  font-weight: 500;
}

.MazInput label, .MazPhoneNumberInput label {
  color: #f5f5f7 !important;
  font-weight: 500;
}

.MazInput .maz__icon, .MazPhoneNumberInput .maz__icon {
  color: #f5f5f7 !important;
}

@media (max-width: 600px) {
  .signup-card {
    width: 98vw;
    padding: 18px 4px 12px 4px;
  }
  h1.text-center {
    font-size: 1.4rem;
  }
}
</style>